import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { css } from "styled-components";

Object.assign(changePasswordActionsStyles, {
    ...changePasswordActionsStyles,
    saveButton: {
        css: css`
            width: 100%;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
    cancelButton: {
        css: css`
            background-color: #999;
            padding: 10px 17px;
            border: none;
            :hover {
                background-color: #999;
            }
        `,
    },
    buttonGridItem: {
        width: 6,
        css: css`
            justify-content: flex-end;
        `,
    },
});
